import { ErrorMessage, useFormikContext } from "formik";
import { updateVariantObject, updateVariants } from "../../Helpers/FormikUpdateFunctions";
import { formatMoney, metaobject, sectionSettings, translations } from "../../Helpers/WindowHelpers";
import Colors from "../Fields/Colors";
import VariantInput from "../Fields/VariantInput";
import Heading from "../Heading";
import { useEffect } from "react";
import ShowMore from "../Displays/ShowMore";
import Modal from "../Fields/ModalSection";
import BonusContent from "../Fields/BonusContent";
import ConfiguratorBonusContent from "../../Interfaces/ConfiguratorBonusContent";
import Select from "../Fields/Select";
import SkirtAndStrapLengths from "../Sections/SkirtAndStrapLengths";

interface Step4Interface {

}

const Step4 = ({ }: Step4Interface) => {
    const context = useFormikContext<any>();

    useEffect(() => {
        const errorKeys = Object.keys(context.errors);

        if (!!errorKeys.length) {
            const firstAvailableElementId = errorKeys.find((key) => document.querySelector(`#${key}`) as HTMLElement)
            if (!firstAvailableElementId) return;
            const firstElement = document.querySelector(`#${firstAvailableElementId}`) as HTMLElement;
            if (firstElement !== document.activeElement) {
                firstElement.focus();
                firstElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }
        }
    }, [context.isSubmitting]);

    const updateColor = (value: string) => {
        const variant = metaobject.color_options.find((item) => item.id == value) || metaobject.upsell_color_options.find((item) => item.id == value);
        updateVariantObject('color', variant, context, 4);
        context.setFieldTouched('color', true);
        context.setFieldValue('color.variantId', variant.id ?? null);
    }

    const updateHandleOption = (value: string) => {
        const variant = metaobject.handle_options.find((item) => item.id == value);
        updateVariantObject('handle_option', variant, context, 4);
    }

    const updateAdditionalHandleOptions = (value: string) => {
        const variant = metaobject.additional_handle_options.find((item) => item.id == value);
        updateVariants('additional_handle_options', variant, context, 4);
    }

    const isUpsell = () => {
        const color = context.values?.color?.variantId;
        if (!color) return false;
        return metaobject.upsell_color_options.some((upsell) => upsell.id == color)
    }

    return (
        <>
            <div className="d--flex flex-column gap-10">
                <Heading
                    level={4}
                    text={metaobject.text.color_heading}
                    classes="d--flex flex-column gap-5"
                    //subtext={isUpsell() ? '' : `${sectionSettings.label_color}: <span class="configurator-selected__selected ">${context.values?.color?.value ?? 'unselected'}</span>`}
                >
                    {!isUpsell() &&
                        <span className="d--flex align-items--center gap-5">
                            {sectionSettings.label_color}: <span className="configurator-selected__selected">{context.values?.color?.value}</span>
                        </span>
                    }
                    {metaobject.text.color_bonus_content?.name &&
                        <>
                            <span className="mr-5">{metaobject.text.color_bonus_content?.name}</span>
                            <Modal
                                classes="link"
                                buttonBody={translations.facets.show_more}>
                                <BonusContent
                                    title={metaobject.text.color_bonus_content?.name || ''}
                                    content={metaobject.text.color_bonus_content} />
                            </Modal>
                        </>
                    }
                </Heading>
                <Colors name={'color'} options={metaobject.color_options} onChange={(e: Event) => updateColor((e.currentTarget as HTMLInputElement).value)} />
            </div>
            {metaobject.upsell_color_options?.length > 0 &&
                <div className="d--flex flex-column gap-10">
                    <Heading
                        level={4}
                        text={metaobject.text.color_heading_2}
                        price={metaobject.upsell_color_options[0]?.price || null}
                        compare={metaobject.upsell_color_options[0]?.compare_at_price || null}
                        classes="d--flex flex-column gap-5"
                        //subtext={`${isUpsell() ? `${sectionSettings.label_color}: <span class="configurator-selected__selected ">${context.values?.color?.value}\n` : ''}</span>`}
                        >
                            {isUpsell() &&
                                <span className="d--flex align-items--center gap-5">
                                    {sectionSettings.label_color}: <span className="configurator-selected__selected">{context.values?.color?.value}</span>
                                </span>}
                            <span className="mr-5">{metaobject.text.upsell_color_bonus_content?.name}</span>
                            <Modal
                                classes="link"
                                buttonBody={translations.facets.show_more}>
                                <BonusContent
                                    title={metaobject.text.upsell_color_bonus_content?.name || ''}
                                    content={metaobject.text.upsell_color_bonus_content} />
                            </Modal>
                    </Heading>
                    <Colors name={'color'} options={metaobject.upsell_color_options} onChange={(e: Event) => updateColor((e.currentTarget as HTMLInputElement).value)} />
                </div>
            }
            {metaobject.handle_options?.length > 0 && (
                <>
                    <Heading
                        level={4}
                        text={metaobject.text.handle_options_heading}
                    />
                    <VariantInput
                        name="handle_option"
                        variants={metaobject.handle_options}
                        inputType="radio"
                        onChange={(e: Event) => updateHandleOption((e.currentTarget as HTMLInputElement).value)}
                        step={4}
                    ></VariantInput> 
                    <ErrorMessage name="handle_option.variantId" component={"div"} className={"configurator-content__error rte links-blue"} />
                </>
            )}
            {metaobject.rolling_covers &&
                <SkirtAndStrapLengths />
            }
            {metaobject.additional_handle_options?.length > 0 ? (
                <Heading
                    level={4}
                    text={metaobject.text.additional_handle_options_heading}
                />
            ) : null}
            {metaobject.additional_handle_options?.length > 0 ? (
                <VariantInput
                    name="additional_handle_options"
                    variants={metaobject.additional_handle_options}
                    inputType="checkbox"
                    onChange={(e: Event) => updateAdditionalHandleOptions((e.currentTarget as HTMLInputElement).value)}
                    step={4}
                ></VariantInput>
            ) : null}
        </>
    );
}

export default Step4;